const inputFieldMaxLength = {
    funFact: 250,
}

export default inputFieldMaxLength;
